<div *ngIf="cargando" class="d-flex justify-content-center mt-5">
    <div class="col-9 text-center mt-5">
        <img src="../../assets/img/mascota-loader.png" style="max-width: 200px;" alt="" class="mb-3">
        <ngb-progressbar type="success" [value]="progreso"></ngb-progressbar>
    </div>
</div>

<div *ngIf="!cargando" class="d-flex justify-content-center px-0 mx-0 mt-5">
    <div class="col col-lg-8">
        <!-- HEADER -->
        <div class="d-flex justify-content-between align-items-center bg-secondary text-white p-3">
            <label class="fs-5 m-0"><span class="vag-bold-font text-uppercase">Inscripción</span> Documentos</label>
            <button (click)="logout()" type="button" class="d-inline-flex btn btn-outline text-white">
                <label class="d-none d-md-block mr-3 fs-5">Salir</label>
                <fa-icon [icon]="powerOffIcon" size="lg" class="text-white"></fa-icon>
            </button>
        </div>
        <div class="menu-cabecera d-flex justify-content-center">
            <div class="col col-lg-8">
                <img src="../../assets/img/step3.png" style="max-width: 100%;" alt="">
            </div>
        </div>

        <div class="mb-5">
            <div class="d-block d-md-flex justify-content-between bg-lightblue text-white py-2 px-3 mb-3">
                <label class="fs-5 m-0">Contrato <span class="vag-bold-font text-uppercase">PRESTACIÓN DE
                        SERVICIOS</span></label>
                <label class="fs-5 m-0" *ngIf="tutor?.time != null">Plaza garantizada <span
                        class="vag-bold-font ml-3">{{tutor?.time?.minutes}}:{{tutor?.time?.seconds}}</span></label>
            </div>
            <h5 class="vag-bold-font text-primary">Por favor escribe tu nombre y apellidos tal cual aparecen en tu
                documento de
                identidad
            </h5>
            <div class="d-block d-md-flex justify-content-between mt-4">
                <div class="col col-md-6 mb-3">
                    <label class="label_title_textfield text-truncate fs-5">Nombre *</label>
                    <input [(ngModel)]="nombresLegales" type="text" class="form-control fs-5"
                        [formControl]="nombresValidator" placeholder="" aria-describedby="basic-addon1">
                </div>
                <div class="col col-md-6 mb-3">
                    <label class="label_title_textfield text-truncate fs-5">Apellidos *</label>
                    <input [(ngModel)]="apellidosLegales" type="text" class="form-control fs-5"
                        [formControl]="apellidosValidator" placeholder="" aria-describedby="basic-addon1">
                </div>
            </div>

            <div class="form-check mb-3">
                <input [(ngModel)]="banderaTerminosCondiciones" class="form-check-input" type="checkbox" value=""
                    id="flexCheckDefault">
                <div class="ml-3">
                    <a href="#" class="text-secondary" for="flexCheckDefault" data-toggle="modal"
                        data-target="#exampleModal">
                        <u>Acepto los Términos y Condiciones del contrato de prestación de servicios</u></a>
                </div>
            </div>

            <div class="d-flex justify-content-between p-2 mt-4">
                <button [routerLink]="['../infoacademica']" type="button"
                    (click)="eliminarTerminosCondiciones(); actualizarIdTutor()"
                    class="btn btn-outline-secondary btn-lg">Atrás</button>
                <button
                    [disabled]="!banderaTerminosCondiciones || nombresValidator.invalid || apellidosValidator.invalid"
                    [ngClass]="{'opacity-1': !banderaTerminosCondiciones || nombresValidator.invalid || apellidosValidator.invalid}"
                    type="button" (click)="aceptarTerminosCondiciones() ; actualizarIdTutor()"
                    class="btn btn-primary btn-lg" [routerLink]="['../pago']">Siguiente</button>
            </div>
            <!-- Modal -->
            <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
                aria-hidden="true">
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Términos y Condiciones</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <p>Razón Social: PLAYBOTS EDUCATION S.L.</p>
                            <p>Domicilio social: Avda. de las Civilizaciones 15, local 9</p>
                            <p>41927 Mairena del Aljarafe – Sevilla</p>
                            <p>C.I.F: B90351719</p>
                            <p>Teléfono: 854 993 164</p>
                            <p>Correo electrónico: info@playbots.es</p>

                            <p>Playbots es una empresa que opera íntegramente desde España</p>

                            <h6>CONDICIONES ESPECIALES</h6>

                            <p><strong>PRIMERA</strong>.- El centro de formación prestará al alumno sus servicios
                                docentes
                                y clases durante el horario y día de la semana seleccionados.
                            </p>

                            <p><strong>SEGUNDA</strong>.- El programa y plan de estudios del curso, que se desarrollará
                                bajo la supervisión de un tutor/profesor,
                                tendrá una duración máxima de diez (10) meses (septiembre-junio),
                                y se desarrollará con arreglo al siguiente esquema: una (1) clase semanal de noventa
                                (90)
                                minutos durante todo el curso escolar,
                                excluyendo los periodos vacacionales, Navidad y Semana Santa, así como los días festivos
                                marcados en el CALENDARIO ESCOLAR DE SEVILLA.
                                El curso consta de sesenta (60) horas lectivas, a razón de 6 horas mensuales.
                                En caso de realizar la matrícula con el curso iniciado, las horas lectivas se calcularán
                                proporcionalmente.
                                Las clases que coincidan con festivos locales, regionales o nacionales, podrán ser
                                recuperadas, siempre que sea posible,
                                dentro de la misma semana del festivo en cuestión, asegurando así la homogeneidad del
                                temario.
                                Las faltas de asistencia no acreditadas se considerarán injustificadas y no serán objeto
                                de
                                recuperación.
                            </p>

                            <p><strong>TERCERA</strong>.- La formación requiere, además de las clases, el siguiente
                                material didáctico: Elementos propios de la academia, que forman parte de los servicios
                                que integran el curso y que se entregan al alumno al comienzo de cada clase (o en el
                                momento
                                que se especifique), y cuyo precio se fija separadamente en la condición siguiente.
                            </p>

                            <p><strong>CUARTA</strong>.- El precio total anual de tales servicios docentes es de
                                quinientos
                                ochenta euros (580 €), o parte equivalente, que corresponden a los siguientes conceptos:
                                a.
                                Inscripción: treinta euros (30 €).
                                No reembolsable en caso de cancelación anticipada. b. Mensualidad: cincuenta y cinco
                                euros
                                (55 €)
                            </p>

                            <p><strong>QUINTA</strong>.- Los precios indicados en la cláusula anterior serán pagados por
                                una de las dos fórmulas alternativas siguientes, a elección del alumno (o su
                                representante).
                                Tarjeta Domiciliación bancaria
                            </p>

                            <p><strong>SEXTA</strong>.- Pago con tarjeta El alumno (o su representante) que seleccione
                                Tarjeta como método de pago, abonará online, a través de la pasarela de pago, la primera
                                mensualidad o parte equivalente, así como el importe íntegro de la cuota de inscripción.
                                Para el abono de las siguientes mensualidades, recibirá un enlace de pago (SMS/Email) al
                                inicio de cada mes.
                            </p>

                            <p><strong>SÉPTIMA</strong>.- Pago Domiciliación bancaria El alumno (o su representante) que
                                seleccione Domiciliación bancaria como método de pago, deberá completar un formulario
                                SEPA
                                para autorizar los cargos bancarios. La no entrega del formulario tendrá como
                                consecuencia
                                la anulación de la Matrícula. Las remesas se llevan a cabo entre los días 1 y 7 de cada
                                mes,
                                excepto la primera mensualidad o parte equivalente, así como el importe íntegro de la
                                cuota
                                de inscripción, que se cargarán en el momento de la Matrícula.</p>

                            <p><strong>OCTAVA</strong>.- Descuento unidad familiar Se aplicará un 10% de descuento sobre
                                el
                                importe de la mensualidad, al segundo y sucesivos alumnos matriculados de la misma
                                unidad
                                familiar.</p>

                            <h6>CONDICIONES GENERALES</h6>

                            <p><strong>PRIMERA</strong>.- Reserva de plaza Cuando se contraten los servicios de
                                enseñanza
                                antes de la fecha del comienzo de las clases del curso, se abonará, en concepto de
                                reserva
                                de plaza, la cantidad establecida en el pliego de condiciones especiales del presente
                                contrato. La cuantía por este concepto no será superior al 25% del curso, y se devolverá
                                o
                                compensará al realizar el pago total del curso.</p>

                            <p><strong>SEGUNDA</strong>.- Pago mensualidades a. Las cuotas en las que difiere el pago
                                del
                                presente contrato, se abonarán por mensualidades adelantadas, dentro de los siete
                                primeros
                                días de cada mes, mediante domiciliación o tarjeta bancaria. b. El retraso por parte del
                                alumno (o su representante) que demore en más de diez (10) días el pago de las
                                cantidades
                                mensuales mencionadas, dará lugar al devengo del interés legal del dinero, o el
                                ejercicio
                                por parte de la academia de la facultad de resolver el contrato. c. Los gastos derivados
                                de
                                las devoluciones de recibos domiciliados deberán ser abonados por el alumno o su
                                representante designado.</p>

                            <p><strong>TERCERA</strong>.- Duración del contrato a. La duración del presente contrato es
                                la
                                prevista para el plan de estudios objeto del mismo, y que se refleja en el pliego de
                                condiciones especiales. No obstante, si por causas de fuerza mayor no imputables al
                                centro
                                de formación, hubiera de suspenderse el servicio, dicho centro lo comunicará al alumno a
                                la
                                mayor brevedad posible, reintegrando al alumno (o su representante) la parte
                                proporcional de
                                todas las cantidades ya abonadas que correspondan a servicios pendientes de ejecución.
                                b.
                                Playbots se reserva el derecho, por razones económicas y organizativas, a cancelar en
                                cualquier momento los grupos que no cuenten con un mínimo de alumnos. El alumno podrá
                                cambiar, dentro de las alternativas disponibles, de curso y/o centro sin coste alguno, o
                                solicitar el reintegro de las cantidades ya abonadas que correspondan a servicios
                                pendientes
                                de ejecución. c. El alumno que abandone el curso, por cualquier causa ajena a su
                                voluntad,
                                debidamente acreditada, que le impida la prosecución del mismo, deberá comunicarlo por
                                escrito, y tendrá derecho al reembolso de la parte proporcional de las cantidades
                                abonadas
                                en concepto de honorarios y que correspondan a servicios pendientes de ejecución, pero
                                no
                                del importe de la cuota de inscripción. Asimismo, aquellos alumnos que sin causa
                                justificada
                                deseen finalizar la prestación de servicios objeto del presente contrato, deberán
                                notificarlo al centro por escrito con quince (15) días de antelación.</p>

                            <p><strong>CUARTA</strong>.- Reintegros En caso de que, por causa de fuerza mayor, el alumno
                                se
                                viera en la necesidad de no iniciar las clases objeto del contrato, el centro
                                reintegrará al
                                mismo el importe íntegro de las cantidades ya pagadas.</p>

                            <p><strong>QUINTA</strong>.- Expedición de diplomas acreditativos A la finalización del
                                contrato, cualquiera que sea la causa que la motive, el centro expedirá al alumno un
                                Diploma
                                acreditativo de los conocimientos adquiridos o nivel alcanzado. Si el nivel de
                                conocimientos
                                no fuere satisfactorio, el centro expedirá un certificado de asistencia, con expresión
                                de la
                                carga docente cursada.</p>

                            <p><strong>SEXTA</strong>.- Reclamaciones a. El centro tiene a disposición de los alumnos
                                Hojas de Reclamaciones conforme al modelo oficial, en su caso. b. Para cualquier
                                controversia que se derive de la interpretación o cumplimiento del presente contrato, el
                                empresario expresamente se somete al sistema arbitral de consumo, a través de la Junta
                                Arbitral de Consumo que corresponda al Centro que imparte la enseñanza.</p>

                            <p><strong>SÉPTIMA</strong>.- Derecho de revocación En el caso que la contratación se
                                efectúe fuera del establecimiento mercantil, bien por el propio empresario, bien por un
                                tercero que actúe por su cuenta, el alumno (o representante) dispone de un plazo de
                                siete (7) días naturales, contados desde la matriculación, para desistir del contrato,
                                con derecho al reintegro de la totalidad de las cantidades abonadas, sin cumplimentar
                                formalidad alguna, y sin que ello suponga penalización alguna.
                            </p>

                            <p><strong>OCTAVA</strong>.- Derecho de desistimiento En el caso que la contratación se
                                efectúe sin la presencia física simultánea del empresario y del alumno (o
                                representante), mediante la utilización de una técnica de comunicación a distancia, el
                                alumno (o representante) disponen de un plazo de siete (7) días hábiles (con arreglo al
                                calendario oficial de su domicilio) para desistir del contrato, con derecho al reintegro
                                de la totalidad de las cantidades abonadas, sin cumplimentar formalidad alguna salvo la
                                comunicación escrita al centro, y sin que ello suponga penalización alguna.</p>

                            <p><strong>NOVENA</strong>.- Consentimiento para envío publicitario Le comunicamos que sus
                                datos serán utilizados con fines comerciales, promocionales, publicitarios y de
                                marketing de los productos y servicios que se oferten por parte de nuestra entidad.</p>

                            <p><strong>DÉCIMA</strong>.- Consentimiento para recabar datos personales De conformidad con
                                los artículo 7 y 13 del Reglamento Europeo 2016/679 (RGDP) del Parlamento Europeo y del
                                Consejo de 27 de Abril de 2016, usted consiente el tratamiento de los datos de carácter
                                personal por parte de PLAYBOTS EDUCATION, S.L. con la finalidad de llevar a cabo el
                                servicio contratado. Los datos recogidos serán guardados y custodiados por el plazo
                                estrictamente necesario, o bien, hasta que usted solicite su supresión. PLAYBOTS
                                EDUCATION, S.L. tratará los datos recogidos con la debida confidencialidad. Si usted se
                                opone al tratamiento de sus datos personales esto haría imposible la realización del
                                servicio así como la respuesta a sus consultas por escrito. No obstante, usted tiene
                                derecho a ejercitar los derechos de acceso, rectificación, supresión, limitación y
                                portabilidad, en la siguiente dirección; Avenida de las Civilizaciones 15, local 9,
                                41927 Mairena del Aljarafe, Sevilla, rellenando la debida solicitud y aportando una
                                copia de su DNI. Puede obtener mayor información sobre la Política de Privacidad de
                                PLAYBOTS EDUCATION, S.L. en nuestra página web www.playbots.es</p>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>